/**
 * Browse occasion deep-link contract (landing Explore + Overview Send a Smile).
 *
 * Query value is always an EVT-NNN catalog slug (never a numeric id).
 * Seasonal nurture CTAs use Overview; public holiday banners use landing Explore.
 */

/** Query param carrying an EVT-NNN catalog slug. */
export const BROWSE_OCCASION_EVENT_TYPE_QUERY_KEY = 'eventType';

/** @deprecated Prefer {@link BROWSE_OCCASION_EVENT_TYPE_QUERY_KEY}. */
export const LANDING_EXPLORE_EVENT_TYPE_QUERY_KEY = BROWSE_OCCASION_EVENT_TYPE_QUERY_KEY;

/** DOM id / hash for the public landing Explore gallery. */
export const LANDING_EXPLORE_SECTION_ID = 'landing-explore';

/** DOM id / hash for Overview "Send a Smile" (nurture OccasionSchedule target). */
export const OVERVIEW_SEND_A_SMILE_SECTION_ID = 'send-a-smile';
